export default __webpack_public_path__ + "static/media/expl_07_EN.17ad1f93.png";